import Vue from "vue";
import Router from "vue-router";
import LoginIndex from "@/view/loginIndex/LoginIndex";
import JgGlIndex from "@/view/jgGlIndex/JgGlIndex";
import RoleGlIndex from "@/view/roleGlIndex/RoleGlIndex";
import SaleOrderGlIndex from "@/view/saleOrderGlIndex/SaleOrderGlIndex";
import SfOrderGlIndex from "@/view/sfOrderGlIndex/SfOrderGlIndex";
import PersonGlIndex from "@/view/personGlIndex/PersonGlIndex";
import CommunityGlIndex from "@/view/communityGlIndex/CommunityGlIndex";
import SchoolGlIndex from "@/view/communityGlIndex/SchoolGlIndex";
import CwGlIndex from "@/view/cwGlIndex/CwGlIndex";
import AccessoriesGlIndex from "@/view/accessoriesGlIndex/AccessoriesGlIndex";
import NewsGlIndex from "@/view/newsGlIndex/NewsGlIndex";
import NewsDetail from "@/view/newsGlIndex/NewsDetail";
import NewsMobileList from "@/view/newsGlIndex/NewsMobileList";
import NewsMobileDetail from "@/view/newsGlIndex/NewsMobileDetail";
import DrawLottery from "@/view/newsGlIndex/DrawLottery";
import Test from "@/view/newsGlIndex/Test";
import HouseInfoIndex from "@/view/houseInfo/HouseInfoIndex";


Vue.use(Router);

export default new Router({
  base: "",
  routes: [
    {
      path: "/",
      name: "loginIndex",
      component: LoginIndex
    },
    {
      path: "/jgGlIndex",
      name: "JgGlIndex",
      component: JgGlIndex
    },
    {
      path: "/roleGlIndex",
      name: "RoleGlIndex",
      component: RoleGlIndex
    },
    {
      path: "/saleOrderGlIndex",
      name: "SaleOrderGlIndex",
      component: SaleOrderGlIndex
    },
    {
      path: "/sfOrderGlIndex",
      name: "SfOrderGlIndex",
      component: SfOrderGlIndex
    },
    {
      path: "/personGlIndex",
      name: "PersonGlIndex",
      component: PersonGlIndex
    },
    {
      path: "/communityGlIndex",
      name: "CommunityGlIndex",
      component: CommunityGlIndex
    },
    {
      path: "/schoolGlIndex",
      name: "SchoolGlIndex",
      component: SchoolGlIndex
    },
    {
      path: "/cwGlIndex",
      name: "CwGlIndex",
      component: CwGlIndex
    },
    {
      path: "/accessoriesGlIndex",
      name: "AccessoriesGlIndex",
      component: AccessoriesGlIndex
    },
    {
      path: "/newsGlIndex",
      name: "NewsGlIndex",
      component: NewsGlIndex
    },
    {
      path: "/newsDetail",
      name: "NewsDetail",
      component: NewsDetail
    },
    {
      path: "/newsMobileList",
      name: "NewsMobileList",
      component: NewsMobileList
    },
    {
      path: "/newsMobileDetail",
      name: "NewsMobileDetail",
      component: NewsMobileDetail
    },
    {
      path: "/drawLottery",
      name: "DrawLottery",
      component: DrawLottery
    },
    {
      path: "/test",
      name: "Test",
      component: Test
    },
    {
      path: "/houseInfoIndex",
      name: "HouseInfoIndex",
      component: HouseInfoIndex
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js